// src/utils/cookie.ts

export const getCookie = ({ name }: { name: string }) => {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
};

export const setCookie = ({ name, value, expiresIn }: { name: string; value: unknown; expiresIn?: number }) => {
  let expiryDate = "";
  if (expiresIn) {
    const date = new Date();
    date.setTime(date.getTime() + expiresIn * 24 * 60 * 60 * 1000);
    expiryDate = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expiryDate + "; path=/";
};

export const deleteCookie = ({ name }: { name: string }) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};
